const animadoAlAparecer = (selector: string, retardo: number = 150) => {
    let elementos: HTMLElement[] = [].slice.call(document.querySelectorAll(selector));
    const observer = new IntersectionObserver((datos) => {
        let espera = 0;

        datos
            .filter(x => x.isIntersecting)
            .forEach(({target}) => {
                const retardoDeElemento = parseInt(target.getAttribute('data-retardo') || retardo.toString(10));

                setTimeout(() => {
                    target.classList.add('is-visible');
                }, espera += retardoDeElemento);

                observer.unobserve(target);
            });
    });

    const actualiza = () => {
        elementos = [].filter.call(document.querySelectorAll(selector), (e: HTMLElement) => {
            return !e.classList.contains('is-visible');
        });

        elementos.forEach(elemento => observer.observe(elemento));
    };

    actualiza();

    return {
        actualiza
    }
};

export default animadoAlAparecer;